module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_02_03.c72cf224.jpg";